import axios from 'axios'

const api = axios.create({
  baseURL: 'https://api.salvemaisum.com.br',
  //baseURL: 'http://192.168.100.10:8889',
})

export default api
